module.exports = __webpack_public_path__ + "staticcomp/img/top.ced3116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/2/top.jpg
// module id = sok5
// module chunks = 39